import { logger } from '@sentry/utils';
import { isSessionExpired } from '../util/isSessionExpired.js';
import { createSession } from './createSession.js';
import { fetchSession } from './fetchSession.js';
/**
 * Get or create a session
 */

function getSession(_ref) {
  var expiry = _ref.expiry,
      currentSession = _ref.currentSession,
      stickySession = _ref.stickySession,
      sessionSampleRate = _ref.sessionSampleRate,
      errorSampleRate = _ref.errorSampleRate;
  // If session exists and is passed, use it instead of always hitting session storage
  var session = currentSession || stickySession && fetchSession();

  if (session) {
    // If there is a session, check if it is valid (e.g. "last activity" time
    // should be within the "session idle time", and "session started" time is
    // within "max session time").
    var isExpired = isSessionExpired(session, expiry);

    if (!isExpired) {
      return {
        type: 'saved',
        session: session
      };
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Session has expired');
    } // Otherwise continue to create a new session

  }

  var newSession = createSession({
    stickySession: stickySession,
    sessionSampleRate: sessionSampleRate,
    errorSampleRate: errorSampleRate
  });
  return {
    type: 'new',
    session: newSession
  };
}

export { getSession };